export default __webpack_public_path__ + "static/media/icon-park-solid_peoples.38e26e7e.svg";